export const getMiddlewareUrl = (options = { useRelativePathOnClient: true }) => {
  if (typeof window !== 'undefined') {
    return options.useRelativePathOnClient ? '' : window.location.origin;
  }

  // override for middleware url
  if (process.env.NEXT_PUBLIC_MIDDLEWARE_URL) {
    return process.env.NEXT_PUBLIC_MIDDLEWARE_URL;
  }

  // vercel preview url — domain name of the generated Git branch URL
  if (process.env.VERCEL_BRANCH_URL) {
    return `https://${process.env.VERCEL_BRANCH_URL}`;
  }

  // default to localhost
  return `http://localhost:${process.env.PORT ?? 3000}`;
};

export const getCheckoutRedirectUrl = () => {
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }

  // override for middleware url
  if (process.env.NEXT_PUBLIC_MIDDLEWARE_URL) {
    return process.env.NEXT_PUBLIC_MIDDLEWARE_URL;
  }

  // Use direct Vercel URL for checkout redirects
  if (process.env.NEXT_PUBLIC_VERCEL_URL) {
    return `https://${process.env.NEXT_PUBLIC_VERCEL_URL}`;
  }

  // default to localhost
  return `http://localhost:${process.env.PORT ?? 3000}`;
};
